"use client";

import React from "react";
import BrandsSliderSection from "../components/BrandsSliderSection";
import HeroSection from "../components/HeroSection";
import ServicesCardSection from "../sections/custom-software-integration/CustomSoftwareIntegrationServicesCardSection";
import ProjectsShowcase from "../components/ProjectsShowcase";
import TechStackTabs from "../components/TechStackTabs";
import WhyChoose from "../components/WhyChoose";
import IntegrationSolutions from "../sections/custom-software-integration/IntegrationSolutions";
import WebsocketUpgrade from "../sections/custom-software-integration/WebsocketUpgrade";
import ExtraSectionsDispatcher from "../components/ExtraSectionsDispatcher";
import { useServiceData } from "../hooks/useServiceData";

export default function CustomSoftwareIntegrationClient() {
  const { data } = useServiceData();

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Custom Software Integration Services",
    serviceType: "System Integration",
    provider: { "@type": "Organization", name: "CodeQlik" },
    areaServed: "Global",
    description:
      "Connect ERP, CRM, accounting, and SaaS tools with reliable integrations. iPaaS/ETL pipelines, webhooks, data mapping, secure auth, and resilient workflows.",
  };

  // Check if we have a dynamic websocketSection in extraSections
  const hasDynamicWebsocket = data?.extraSections?.some(s => s.type === 'websocketSection');

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      {/* Hero section */}
      <HeroSection dynamicData={data?.hero} />
      {/* Brands slider */}
      <BrandsSliderSection dynamicData={data?.brands} />
      {/* Service cards */}
      <ServicesCardSection dynamicData={data?.services} />
      {/* Integration tiles section */}
      <IntegrationSolutions />
      
      {/* Websocket upgrade section - Only show static if dynamic is NOT present in extraSections */}
      {!hasDynamicWebsocket && <WebsocketUpgrade />}
      
      {/* Render all extra sections from backend */}
      <ExtraSectionsDispatcher />

      {/* Projects section */}
      <ProjectsShowcase dynamicData={data?.portfolio} />
      {/* TechStackTabs section */}
      <TechStackTabs dynamicData={data?.technologies} />
      {/* WhyChoose Section */}
      <WhyChoose dynamicData={data?.features} />
    </>
  );
}
